import React from 'react';

const TableActionsCol = ({ actions }) => {
  return (
    <div className='table-actions'>
      {actions.map((item, index) => (
        <button
          key={index}
          className='table-actions__link'
          onClick={item.action}
        >
          {item.label}
        </button>
      ))}
    </div>
  )
}

export default TableActionsCol;
